<template>
    <select v-model="selectedCountry" v-on:change="onCountryChange()">
        <option value="">Country</option>
        <option v-for="(cName, cCode) in countries" v-bind:value="cCode">{{ cName }}</option>
    </select>
</template>

<script type="text/jsx">
    export default {
        name: 'country-selector',
        data: function () {
            return this.getDefaultData();
        },
        props: {
            countries: {
                type: Object,
                required: true
            },
            country: {
                type: String,
                required: true,
                default: function () {
                    return '';
                }
            }
        },
        methods: {
            onCountryChange: function () {
                this.$emit('country-change', this.selectedCountry);
            },
            getDefaultData: function () {
                return {
                    selectedCountry: this.country
                };
            },
            reset: function() {
                Object.assign(this.$data, this.getDefaultData());
            }
        },
        watch: {
            country: function (val) {
                // have to clean-up selected state/province value to default when country changes
                this.selectedCountry = val;
            }
        }

    }
</script>


// WEBPACK FOOTER //
// country-selector.vue?255c1d5b